import { AuthProvider } from "./context/AuthContext";
import { NavProvider, useNav } from "./context/NavContext";
import BottomTabBar from "./components/BottomTabBar";
import HomeScreen from "./screens/HomeScreen";
import LoanDetailsScreen from "./screens/LoanDetailsScreen";
import RejectedScreen from "./screens/RejectedScreen";
import ProfileScreen from "./screens/ProfileScreen";

// ── Router ────────────────────────────────────────────────────────────────────

function Router() {
  const { screen } = useNav();

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", position: "relative", background: "#0a1628", minHeight: "100dvh" }}>
      {screen === "home"        && <HomeScreen />}
      {screen === "loanDetails" && <LoanDetailsScreen />}
      {screen === "rejected"    && <RejectedScreen />}
      {screen === "profile"     && <ProfileScreen />}
      <BottomTabBar />
    </div>
  );
}

// ── Root ──────────────────────────────────────────────────────────────────────

export default function App() {
  return (
    <AuthProvider>
      <NavProvider>
        <Router />
      </NavProvider>
    </AuthProvider>
  );
}
